// Internal Jig scene-graph wrappers (see JIG_FORMAT_GUIDE / JIG_FORMAT_GOTCHAS).
// These nodes are transform helpers, not user-facing parts to enrich or target.

var STRICT_INTERNAL_JIG_NODE_TOKENS: Record<string, boolean> = {
  innerparent: true,
  sceneroot: true,
}

var AMBIGUOUS_INTERNAL_JIG_NODE_TOKENS: Record<string, boolean> = {
  root: true,
  pivot: true,
  empty: true,
}

function normalizeName(value: unknown): string {
  return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

function trailingToken(name: string): string {
  if (!name) {
    return ''
  }
  var parts = name.split('_').filter(Boolean)
  return parts.length ? parts[parts.length - 1] : name
}

function hasGuidPrefix(name: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/.test(name)
}

function exactInternalToken(name: string): boolean {
  return !!STRICT_INTERNAL_JIG_NODE_TOKENS[name] || !!AMBIGUOUS_INTERNAL_JIG_NODE_TOKENS[name]
}

function classifyInternalReference(name: unknown): string | null {
  var normalized = normalizeName(name)
  if (!normalized) {
    return null
  }

  if (STRICT_INTERNAL_JIG_NODE_TOKENS[normalized]) {
    return 'strict'
  }
  if (AMBIGUOUS_INTERNAL_JIG_NODE_TOKENS[normalized]) {
    return 'ambiguous'
  }

  var token = trailingToken(normalized)
  if (STRICT_INTERNAL_JIG_NODE_TOKENS[token]) {
    return 'strict'
  }
  if (AMBIGUOUS_INTERNAL_JIG_NODE_TOKENS[token] && hasGuidPrefix(normalized)) {
    return 'ambiguous'
  }

  return null
}

export function isInternalJigNodeReference(name: unknown): boolean {
  return classifyInternalReference(name) !== null
}

export function isInternalJigElement(element: any): boolean {
  var objectCandidates = [
    element && element.ElementData ? element.ElementData.ObjectName : undefined,
    element ? element.ObjectName : undefined,
    element ? element.ElementUniqueName : undefined,
  ]

  var displayCandidates = [
    element && element.ElementData ? element.ElementData.Name : undefined,
    element ? element.Name : undefined,
  ].map(normalizeName).filter(Boolean)

  var hasObjectMatch = objectCandidates.some(function (candidate) {
    return classifyInternalReference(candidate) !== null
  })
  if (hasObjectMatch) {
    return true
  }

  var hasInternalDisplayToken = displayCandidates.some(exactInternalToken)
  var hasObjectIdentity = objectCandidates.some(function (candidate) {
    return normalizeName(candidate).length > 0
  })
  return !hasObjectIdentity && hasInternalDisplayToken
}
